module.exports = __webpack_public_path__ + "img/ico_component_search.3851e302.svg";